import { commonFilter } from './filter';

export default {
  pageName: 'CommunityStreaming',
  pageId: '20103',
  pagePath: '/opinion/Community/Streaming',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
